import React from "react";

const ReportCardSkeleton: React.FC = () => {
  return (
    <div className="relative bg-gray-50 border border-gray-200 rounded-lg p-4 mb-1 hover:bg-gray-100 transition cursor-pointer animate-pulse">
      <div className="flex justify-between items-start">
        <div className="flex-grow">
          {/* Text label (e.g., N3) */}
          <div className="h-[1.5rem] w-12 bg-gray-200 rounded mb-1" />

          {/* Report title */}
          <div className="h-5 w-3/4 bg-gray-300 rounded mb-1" />

          {/* Creator and timestamp */}
          <div className="h-4 w-1/2 bg-gray-200 rounded mb-3" />

          {/* Description (fixed height of 4 lines) */}
          <div className="space-y-1">
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="h-4 w-[95%] bg-gray-200 rounded" />
            <div className="h-4 w-[90%] bg-gray-200 rounded" />
            <div className="h-4 w-[85%] bg-gray-200 rounded" />
          </div>
        </div>

        {/* Three-dot button */}
        <div className="absolute top-3 right-2">
          <div className="w-4 h-4 2xl:w-5 2xl:h-5 bg-gray-300 rounded-full" />
        </div>
      </div>

      {/* Bottom bar: lock icon and view count */}
      <div className="flex items-center justify-between mt-4 text-gray-500">
        <div className="flex items-center space-x-1">
          <div className="w-5 2xl:w-[1.35rem] h-5 bg-gray-300 rounded" />
          <div className="h-4 w-12 bg-gray-200 rounded" />
        </div>
        <div className="flex items-center space-x-1">
          <div className="w-5 2xl:w-6 h-5 2xl:h-6 bg-gray-300 rounded" />
          <div className="h-4 w-4 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export default ReportCardSkeleton;
